const state = () => ({
  activeTourName: null,
  lockNavDrawer: false,

  showEndObBoardDialog: false,
})

const mutations = {
  startTour(state, name) {
    state.activeTourName = name
  },
  stopTour(state) {
    state.activeTourName = null
  },

  lockNavDrawer(state, val) {
    state.lockNavDrawer = val
  },

  setShowEndObBoardDialog(state, val) {
    state.showEndObBoardDialog = val
  }
}

const getters = {
  isAnyTourRunning: (state) => !!state.activeTourName,
  currentTourName: (state) => state.activeTourName,
  lockNavDrawer: (state) => state.lockNavDrawer,
  showEndObBoardDialog: (state) => state.showEndObBoardDialog,
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
